<template>
  <div class="header__wrapper fixed w-full bg-body-primary z-header max-h-[60px]">
    <header class="header header--desktop mx-auto flex items-center">
      <div class="brand font-bold mr-5 h-[60px] u-center">
        <OneDioLogo />
      </div>
      <div class="header__menu ml-auto flex flex-shrink-0 h-[60px] z-header">
        <PopoverMenu />
      </div>
      <div class="header__actions ml-auto flex flex-shrink-0 h-[60px]">
        <PopoverConversations v-if="isLoggedIn" title="Mesajlar" />
        <PopoverNotifications v-if="isLoggedIn" title="Bildirimler" />
        <PopoverSearch />
        <PopoverUser v-if="isLoggedIn" />
        <OButton v-if="!isLoggedIn" aria-label="giriş yap" pure class="u-center w-12 h-full hover:bg-alpha-5" @click="handleLoginModal">
          <OIcon icon="user" class="w-[22px]" />
        </OButton>
      </div>
    </header>
    <nav class="w-full bg-black-90 h-10 mr-8 u-center">
      <div class="nav--desktop w-full flex items-center">
        <BreakingNews v-if="IS_ONEDIO" />
        <BreakingNewsOld v-else />
        <MenuBadgeItem v-if="IS_ONEDIO" />
      </div>
    </nav>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import OneDioLogo from './OneDioLogo.vue';
import PopoverSearch from './PopoverSearch.vue';
import BreakingNewsOld from '~/modules/common/components/app/header/BreakingNewsOld';
import MenuBadgeItem from '~/modules/badges/components/MenuBadgeItem';
import { OButton, OIcon } from '~/modules/common/components/ui';
import { useAuth } from '~/modules/auth/state/useAuth';
import PopoverMenu from '~/modules/common/components/app/header/PopoverMenu';
import { useModal } from '~/composables/useModal';
import BreakingNews from '~/modules/common/components/app/header/BreakingNews';
import { IS_ONEDIO } from '~/constants/config';

export default defineComponent({
  components: {
    BreakingNews,
    PopoverNotifications: () =>
      import(/* webpackChunkName: "PopoverNotifications" */ '~/modules/common/components/app/header/PopoverNotifications'),
    OButton,
    PopoverSearch,
    PopoverMenu,
    OneDioLogo,
    PopoverUser: () => import(/* webpackChunkName: "PopoverUser" */ './PopoverUser.vue'),
    PopoverConversations: () => import(/* webpackChunkName: "PopoverConversations" */ './PopoverConversations.vue'),
    MenuBadgeItem,
    BreakingNewsOld,
    OIcon,
  },
  setup() {
    const { isLoggedIn } = useAuth();
    const { openLoginModal } = useModal();
    const handleLoginModal = async () => {
      await openLoginModal();
    };

    return {
      isLoggedIn,
      handleLoginModal,
      IS_ONEDIO,
    };
  },
});
</script>

<style lang="scss">
.header__wrapper {
  //box-shadow: 1px 0 3px rgba(0, 0, 0, 0.2);
}
.header--desktop {
  max-width: 1299px;
}
.nav--desktop {
  max-width: 1299px;
}
</style>
